import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchProjects, createProject, updateProject, deleteProject } from "../api/administrationService";

export const useProjects = () => {
  const queryClient = useQueryClient();

  // Obtener los proyectos
  const {
    data: projects = [],
    error,
    isLoading,
  } = useQuery({
    queryKey: ["projects"],
    queryFn: fetchProjects,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  // Invalidar caché tras una mutación
  const invalidateProjectsCache = () => {
    queryClient.invalidateQueries({ queryKey: ["projects"] });
  };

  // Mutación para crear un proyecto
  const createMutation = useMutation({
    mutationFn: createProject,
    onSuccess: invalidateProjectsCache,
  });

  // Mutación para actualizar un proyecto
  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateProject(id, data),
    onSuccess: invalidateProjectsCache,
  });

  // Mutación para eliminar un proyecto
  const deleteMutation = useMutation({
    mutationFn: deleteProject,
    onSuccess: invalidateProjectsCache,
  });

  return {
    projects,
    error,
    isLoading,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
